export default __webpack_public_path__ + "static/media/23w.96b7d76c.svg";